import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

export default function GladlyProfileRow({ profileRow }) {
  return (
    <tr className="externalCustomerLookupSearchResults-table-gladlyProfileRow" key={`externalCustomer-gladlyCustomer`}>
      <td className="externalCustomerLookupSearchResults-table-sourceCell">
        <i className="externalCustomerLookupSearchResults-table-sourceCell-gladlyLogo" />
      </td>
      <td className="externalCustomerLookupSearchResults-table-selectorSpacer" />
      {_.map(profileRow, (value, i) => (
        <td key={`gladlyCustomer-${i}`}>{value}</td>
      ))}
    </tr>
  );
}

GladlyProfileRow.propTypes = {
  profileRow: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/external_customer_lookup/gladly_profile_row.jsx